import script from "./insights-left-drawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./insights-left-drawer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__